// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bhj_a bii_bi"};